module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Compiling-4a785e397a6540508e102e93ca428a98.svg";